import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/shop_item/shop_item_shadow.png';

const StyledTopShadow = styled.div`
	position: absolute;
	top: -210px;
	left: 50%;
	transform: translateX(-50%);
	width: 420px;
	height: 420px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledImageContainer = styled.div<{ $type: 'vehicle' | 'clothes' }>`
	position: absolute;
	${(props) =>
		props.$type === 'vehicle' &&
		css`
			top: 50px;
		`}
	${(props) =>
		props.$type === 'clothes' &&
		css`
			bottom: 60px;
		`}
left: 50%;
	transform: translateX(-50%);
	transition:
		top 0.3s ease,
		bottom 0.3s ease;

	img {
		transition:
			height 0.3s ease,
			scale 0.3s ease;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 140px;
	bottom: 1px;
	left: 0;
	z-index: 3;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
	transition:
		opacity 0.3s ease,
		height 0.3s ease;
`;

const StyledHoverShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 140px;
	bottom: 1px;
	left: 0;
	z-index: 3;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0;
	transition:
		opacity 0.3s ease,
		height 0.3s ease;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 17px;
	left: 20px;
	z-index: 4;
	display: flex;
	flex-direction: column;

	& > ${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}

	button {
		padding: 0 10px;
		border-radius: 5px;
		margin-top: 16px;
	}
`;

const StyledMoreBlock = styled.div`
	align-self: flex-start;
	width: fit-content;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-top: 0;
	height: 0;
	overflow: hidden;
	transition:
		height 0.3s ease,
		margin-top 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	&:hover ${Text}, &:hover img {
		opacity: 1;
	}
`;

const StyledPriceContainer = styled.div`
	position: relative;
	display: flex;
	gap: 10px;
	justify-content: flex-start;
	align-items: center;
	margin: 14px 0 0;
	transition: margin 0.3s ease;
`;

const StyledPrice = styled.div<{ $isDonate?: boolean }>`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 20px;
		color: ${(props) => (props.$isDonate ? '#FFBB00' : '#ffffff')};
		padding-top: 1px;
		transition: color 0.3s ease;
	}
`;

const StyledOldPrice = styled.div`
	position: relative;
	display: flex;
	gap: 6px;
	padding: 0 5px;
	margin-top: 2px;

	img {
		width: 12px;
		height: 12px;
		margin-top: 2px;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
		filter: grayscale(100%);
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
		transition: color 0.3s ease;
	}

	.line {
		position: absolute;
		top: 7px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ff3737;
	}
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 3px 5px;
	background: #ffffff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

const StyledDiscountContainer = styled.div`
	padding: 3px 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledContainer = styled.div<{
	$type: 'vehicle' | 'clothes';
	$pointerCursor?: boolean;
}>`
	position: relative;
	width: auto;
	min-width: 290px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	overflow: hidden;
	cursor: ${(props) => (props.$pointerCursor ? 'pointer' : 'default')};
	transition:
		background-color 0.3s ease,
		border 0.3s ease,
		box-shadow 0.3s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.1);
		border: 1px solid #ffffff;
		box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.1);

		${StyledImageContainer} {
			${(props) =>
				props.$type === 'vehicle' &&
				css`
					/* top: 40px; */
				`}
			${(props) =>
				props.$type === 'clothes' &&
				css`
					/* bottom: 50px; */
				`}

    img {
				${(props) =>
					props.$type === 'vehicle' &&
					css`
						scale: 1.21;
					`}
				${(props) =>
					props.$type === 'clothes' &&
					css`
						scale: 1.14;
					`}
			}
		}

		${StyledShadow}, ${StyledHoverShadow} {
			opacity: 1;
			height: 180px;
		}

		${StyledMoreBlock} {
			height: 12px;
			margin-top: 16px;
		}
	}
`;

const StyledTagsContainer = styled.div`
	position: absolute;
	top: 20px;
	left: 20px;
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	justify-content: flex-start;
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledDiscountContainer,
	StyledDiscountTimerContainer,
	StyledHoverShadow,
	StyledImageContainer,
	StyledMoreBlock,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
	StyledTagsContainer,
	StyledTimerContainer,
	StyledTopShadow,
};
